import { keyBy, mergeWith, cloneDeep, map, isFinite } from "lodash"

// Columns will be in the following order (handled by useModeInstruments)
// | Original | Rebalanced or Comparison | Delta |
export function addDeltaColumn(data) {
  // Convert array of values into objects keyed by id for easier comparison
  const keyedData = data.map(({ values, summary }) => ({
    values: keyBy(values, "id"),
    summary,
  }))

  // Calculate delta between first and second data points
  const delta = mergeWith(
    cloneDeep(keyedData[0]),
    keyedData[1],
    (existingValue, newValue) => {
      // If the existing value is not a number but the new value is, return the negative of the new value which corresponds to (0 - newValue)
      if (isFinite(newValue) && !isFinite(existingValue)) {
        return -newValue
      }

      // Only calculate difference if both values are finite numbers, if not, use default merge behavior
      return (!isFinite(existingValue) || !isFinite(newValue))
        ? undefined
        : existingValue - newValue
    },
  )

  // Calculate delta for performance summary values
  const performanceSummaryDelta = keyedData.length > 1 && isFinite(keyedData[1].summary) && isFinite(keyedData[0].summary)
    ? keyedData[1].summary - keyedData[0].summary
    : undefined

  // Add delta as third data point
  keyedData.push({
    values: delta.values,
    summary: performanceSummaryDelta,
  })

  // Convert back to array format for rendering
  return keyedData.map(({ values, summary }) => ({
    values: map(values),
    summary,
  }))
}
